export const CURRENT_MEETING = "prevent_meet_03_24";
